import React from 'react';
import { IonItem, IonLabel, IonList } from '@ionic/react';
import { FarecardHistory } from '../../services/types/apitypes';
import './CardHistoryDate.css';
import { datesFormatTime, datesFromString } from '../../utils/dates';

type CardHistoryDateProps = {
  date: string;
  history: any;
};

export default function CardHistoryDate({
  date,
  history,
}: CardHistoryDateProps) {
  const items: FarecardHistory[] = history[date];

  const getTime = (item: FarecardHistory) => {
    const date = datesFromString(item.timestamp);
    return datesFormatTime(date);
  };

  return (
    <div className="farcard-history-date pb-3">
      <h1 className="h1 pb-1"> {date}</h1>
      <IonList inset={false} className="farcard-history-list">
        {items &&
          items.map((item: FarecardHistory, i: number) => {
            return (
              <IonItem key={i}>
                <IonLabel className="farcard-history-label">
                  <div>
                    <em>{getTime(item)}</em>
                  </div>
                  <div className="pt-1 pb-1">
                    <b>{item.title || item.type}</b>
                  </div>
                  {item.description && <div>{item.description}</div>}
                  {(item.line || item.stop) && (
                    <div className="farcard-history-fare">
                      {item.line && <div>{item.line}</div>}
                      {item.stop && <div>{item.stop}</div>}
                    </div>
                  )}
                </IonLabel>
                <span slot="end">
                  <b>$ {item.price}</b>
                </span>
              </IonItem>
            );
          })}
      </IonList>
    </div>
  );
}
